class ProductGalleryScrollIndicator {
  constructor() {
    this.mediaGallery = null;
    this.galleryViewer = null;
    this.mediaList = null;
    this.indicator = null;
    this.thumb = null;
    this.isInitialized = false;

    this.init();
  }

  init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.setup());
    } else {
      this.setup();
    }
  }

  setup() {
    this.mediaGallery = document.querySelector('media-gallery');
    if (!this.mediaGallery) return;

    this.galleryViewer = this.mediaGallery.querySelector('[id^="GalleryViewer"]');
    this.mediaList = this.mediaGallery.querySelector('.product__media-list');
    this.indicator = this.mediaGallery.querySelector('.product-gallery-scroll-indicator');
    this.thumb = this.indicator?.querySelector('.scroll-indicator__thumb');

    if (!this.mediaList || !this.indicator || !this.thumb) return;

    this.isInitialized = true;
    this.attachEventListeners();
    this.updateIndicator();
  }

  attachEventListeners() {
    window.addEventListener('scroll', () => this.updateIndicator());
    this.mediaList.addEventListener('scroll', () => this.updateIndicator());

    window.addEventListener('resize', () => {
      this.updateIndicator();
    });

    const observer = new MutationObserver(() => this.updateIndicator());
    observer.observe(this.mediaList, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style']
    });

    setTimeout(() => this.updateIndicator(), 100);
  }

  updateIndicator() {
    if (!this.isInitialized) return;

    const isMobile = window.innerWidth < 750;

    if (isMobile) {
      this.updateMobileIndicator();
    } else {
      this.updateDesktopIndicator();
    }
  }

  updateMobileIndicator() {
    const mediaItems = this.mediaList.querySelectorAll('.product__media-item');

    if (mediaItems.length === 0) {
      this.indicator.style.opacity = '0';
      return;
    }

    const firstItem = mediaItems[0];
    const lastItem = mediaItems[mediaItems.length - 1];
    const firstRect = firstItem.getBoundingClientRect();
    const lastRect = lastItem.getBoundingClientRect();

    const galleryContentTop = firstRect.top + window.scrollY;
    const galleryContentBottom = lastRect.bottom + window.scrollY;

    const viewportTop = window.scrollY;
    const viewportBottom = viewportTop + window.innerHeight + 400;

    if (galleryContentBottom < viewportTop || galleryContentTop > viewportBottom) {
      this.indicator.style.opacity = '0';
      return;
    }

    this.indicator.style.opacity = '1';

    const viewportHeight = window.innerHeight;
    const viewportCenter = viewportTop + (viewportHeight / 2);

    const scrollStart = galleryContentTop;
    const scrollEnd = galleryContentBottom;
    const scrollRange = scrollEnd - scrollStart;

    let scrollProgress = 0;
    if (viewportCenter >= scrollStart && viewportCenter <= scrollEnd) {
      scrollProgress = (viewportCenter - scrollStart) / scrollRange;
    } else if (viewportCenter > scrollEnd) {
      scrollProgress = 1;
    }

    scrollProgress = Math.max(0, Math.min(1, scrollProgress));

    const trackHeight = this.indicator.offsetHeight;
    const thumbHeight = Math.max(20, Math.min(60, trackHeight / Math.max(mediaItems.length, 2)));
    const maxThumbTop = trackHeight - thumbHeight;
    const thumbTop = scrollProgress * maxThumbTop;

    this.thumb.style.height = `${thumbHeight}px`;
    this.thumb.style.transform = `translateY(${thumbTop}px)`;
  }

  updateDesktopIndicator() {
    const mediaItems = this.mediaList.querySelectorAll('.product__media-item');

    if (mediaItems.length === 0) {
      this.indicator.style.opacity = '0';
      return;
    }

    const galleryRect = this.mediaList.getBoundingClientRect();
    const galleryTop = galleryRect.top + window.scrollY;
    const galleryHeight = this.mediaList.scrollHeight;

    const viewportTop = window.scrollY;
    const viewportBottom = viewportTop + window.innerHeight;
    const galleryBottom = galleryTop + galleryHeight;

    if (galleryBottom < viewportTop || galleryTop > viewportBottom) {
      this.indicator.style.opacity = '0';
      return;
    }

    this.indicator.style.opacity = '1';

    const viewportHeight = window.innerHeight;
    const viewportCenter = viewportTop + (viewportHeight / 2);

    const scrollStart = galleryTop;
    const scrollEnd = galleryTop + galleryHeight;
    const scrollRange = scrollEnd - scrollStart;

    let scrollProgress = 0;
    if (viewportCenter >= scrollStart && viewportCenter <= scrollEnd) {
      scrollProgress = (viewportCenter - scrollStart) / scrollRange;
    } else if (viewportCenter > scrollEnd) {
      scrollProgress = 1;
    }

    scrollProgress = Math.max(0, Math.min(1, scrollProgress));

    const trackHeight = this.indicator.offsetHeight;
    const thumbHeight = Math.max(40, Math.min(120, trackHeight / Math.max(mediaItems.length, 3)));
    const maxThumbTop = trackHeight - thumbHeight;
    const thumbTop = scrollProgress * maxThumbTop;

    this.thumb.style.height = `${thumbHeight}px`;
    this.thumb.style.transform = `translateY(${thumbTop}px)`;
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new ProductGalleryScrollIndicator();
  });
} else {
  new ProductGalleryScrollIndicator();
}
